/* istanbul ignore file */
import {
  cusorOverrideZoomInIcon,
  cusorOverrideZoomOutIcon,
} from '@noths/polaris-client-ribbons-design-system';
import { shadowRight, shadowUp, smallElevation } from '@noths/polaris-client-styles';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

import {
  PRODUCT_MEDIA_TABPANEL_CLASS,
  ZOOM_PAN_CONTENT_CLASS,
  ZOOM_PAN_WRAPPER_CLASS,
} from 'src/components/organisms/ProductMediaCarousel/constants/elementIds';
import { getIconPath } from 'src/utils/assetPaths';

const CLOSE = getIconPath('icons-24-close.svg');

const { colors, spacing } = themeVariables;
const THUMBNAILS_HEIGHT = 150;
const HEADER_HEIGHT = 80;

export const header = css`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-shrink: 0;
  padding: var(${spacing.md});
`;

export const closeButton = css`
  width: 48px;
  height: 48px;
  padding: 0;
  display: block;
  border: none;
  background-color: transparent;
  background-image: url(${CLOSE});
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
  ${smallElevation};
  border-radius: 50%;
`;

export const fullScreenMedia = css`
  width: 100%;
  height: 100%;
  object-fit: contain;
  margin: 0 auto;
`;

export const mediaContainer = css`
  width: 100%;
  flex-grow: 1;
  position: relative;
  height: calc(100% - ${THUMBNAILS_HEIGHT + HEADER_HEIGHT}px);

  .${PRODUCT_MEDIA_TABPANEL_CLASS} {
    background: none;
    height: 100%;
  }

  .${ZOOM_PAN_WRAPPER_CLASS}, .${ZOOM_PAN_CONTENT_CLASS} {
    height: 100%;
    width: 100%;
  }
`;

export const tabpanel = css`
  position: relative;
  height: 100%;

  .${ZOOM_PAN_WRAPPER_CLASS}, .${ZOOM_PAN_CONTENT_CLASS} {
    height: 100%;
    width: 100%;
  }
`;

export const keyboardNavigationText = css`
  position: absolute;
  bottom: 1rem;
  left: 50%;
  transform: translate(-50%, 0);
  background-color: rgb(255, 255, 255);
  border-radius: 0.625rem;
  padding: 6px 0.5rem;
  margin: 0px;
  font-size: 0.75rem;
  border: none;

  &[data-has-focus='false'] {
    clip: rect(0, 0, 0, 0);
  }
`;

export const zoomWrapper = css`
  width: 100%;
  height: 100%;

  &[data-has-zoomed='true'] {
    ${cusorOverrideZoomOutIcon}
  }
  &[data-has-zoomed='false'] {
    ${cusorOverrideZoomInIcon}
  }
`;

export const thumbnails = css`
  display: block;
  width: 100%;
  height: ${THUMBNAILS_HEIGHT}px;
  padding: var(${spacing.sm});
  background-color: var(${colors.surface.default});
  z-index: 1;
  ${shadowUp};
  ${shadowRight};
`;

export const imageNumberContainer = css`
  text-align: center;
  margin-bottom: var(${spacing.sm});
`;
